<template>
    <div class="col-12 nopads">
        <div
            class="data-list-item add"
            @click.stop="$emit('add')"
        >
            <div class="item-img-cont add-title">
                <i class="fa fa-plus"/>
            </div>
            <div class="item-text-cont">
            <span class="item-title-add">
              {{ $t('common.add_new') }}
            </span>
                <font-awesome-icon
                    icon="eye"
                    class="card-body-icon"
                />
            </div>
        </div>
        <div class="col-12 list-container nopads my-2">
            <Transition name="fade">
                <div v-if="tableItems.length > 0" class="col-sm-12 list-content result-table">
                    <vue3-datatable
                        ref="resultTable"
                        :rows="tableItems"
                        :columns="fields"
                        :pagination="false"
                        :sticky-header="true"
                        height="100%"
                        :sortable="true"
                        skin="bh-table-compact"
                        row-class="routa-table-row"
                        cell-class="routa-table-cell"
                        @row-click="onRowClicked"
                    />
                </div>
            </Transition>
        </div>
    </div>
</template>

<script>
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'ObservationTypeList',
    components: {Vue3Datatable},
    props: {
        results: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data() {
        return {
            tableItems: [],
            fields: [
                {field: 'id', title: this.$t('observations.id'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'name', title: this.$t('observations.type'), sort: true, headerClass: 'routa-table-header'},
                {field: 'group', title: this.$t('observations.group'), sort: true, headerClass: 'routa-table-header'},
                {field: 'geomType', title: this.$t('observations.geometry_type'), sort: true, headerClass: 'routa-table-header'}
            ]
        }
    },
    watch: {
        results() {
            this.initTableItems()
        }
    },
    mounted() {
        this.initTableItems()
    },
    methods: {
        initTableItems() {
            this.tableItems = []
            const temp = []
            this.results.forEach(item => {
                temp.push({
                    id: item.id,
                    name: item.name,
                    group: item.observation_group.name,
                    geomType: item.geometry_type === 1 ? this.$t('observations.point') : this.$t('observations.line')
                })
            })
            this.$nextTick(() => {
                this.tableItems = temp
            })
        },
        onRowClicked(item) {
            let ot = this.results.find(o => o.id === item.id)
            this.$emit('edit', ot)
        }
    }
}
</script>
